<svg
  [attr.viewBox]="store.getViewBoxString$(isInsideZoomPanel) | async"
  [class.round-container]="isInsideZoomPanel"
  preserveAspectRatio="xMidYMid meet"
>
  <foreignObject
    #container
    [attr.width]="store('sensorRendererState')('width').$ | async"
    [attr.height]="store('sensorRendererState')('height').$ | async"
  >
    <div xmlns="http://www.w3.org/1999/xhtml">
      <canvas
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        #canvas
        [attr.width]="store('sensorRendererState')('width').$ | async"
        [attr.height]="store('sensorRendererState')('height').$ | async"
        (mousedown)="handleMouseEvent($event)"
        (mousemove)="handleMouseEvent($event)"
        (click)="handleMouseEvent($event)"
        (dblclick)="handleMouseEvent($event)"
        (wheel)="handleMouseEvent($event)"
      ></canvas>
    </div>
  </foreignObject>
</svg>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isInEditMode$ | async"
>
  <div
    class="color-tooltip"
    [style.transform]="transform$ | async"
    *ngIf="currentPixelColor$ | async as currentPixelColor"
  >
    <span>{{ currentPixelColor }}</span>
  </div>
</ng-template>
